import { CoverageForm } from "@models/MLTC_R3/Coverage.model";
import { keys, reduce } from "lodash";

export const validate = (values: CoverageForm) => {
    const fields = keys(values);
    const errors: any = reduce(
      fields,
      (result, field: string) => {
        return { ...result, [field]: values };
      },
      {}
    );
    return errors;
};
